import * as React from "react";

const CCBannerGoldUnion = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#paint0_angular_8669_22309_clip_path)">
      <g transform="matrix(-0.0122993 0.0124162 -0.0124162 -0.0122993 12.8837 12)">
        <foreignObject x="-1010.52" y="-1010.52" width="2021.03" height="2021.03">
          <div
            style={{ background: "conic-gradient(from 90deg,rgba(89, 195, 105, 1) 0deg,rgba(47, 186, 67, 1) 360deg)", height: "100%", width: "100%", opacity: 1 }}
          />
        </foreignObject>
      </g>
    </g>
    <rect x="0.161133" width="24" height="24" rx="3.01255" fill="url(#paint0_angular_8669_22309)" />
    <g filter="url(#filter0_d_8669_22309)">
      <path d="M13.7305 2.53296L12.7148 7.64526C12.2022 10.2278 14.0293 12.3215 16.6943 12.324L21.8887 12.3279L21.4473 14.5476H15.6045L15.4053 14.5427C14.9437 14.5185 14.512 14.4098 14.1289 14.2273C14.068 14.1982 13.9957 14.2263 13.9521 14.2761C13.9206 14.3121 13.9038 14.3591 13.918 14.405C14.0311 14.7754 14.0733 15.1752 14.04 15.5876C14.029 15.7256 14.0101 15.8642 13.9824 16.0037L12.8975 21.4666H10.5742L11.5898 16.3542C12.102 13.7715 10.2747 11.678 7.60938 11.6755L2.41504 11.6716L2.85645 9.4519H8.69922C9.23594 9.4519 9.73703 9.56363 10.1748 9.77222C10.2404 9.8036 10.3193 9.7692 10.3613 9.71265C10.3858 9.67897 10.3983 9.63679 10.3857 9.59546C10.2726 9.22515 10.2313 8.82531 10.2637 8.41284C10.2748 8.27481 10.2936 8.13542 10.3213 7.99585L11.4062 2.53296H13.7305ZM7.44141 12.3943C9.93224 12.3945 11.2632 14.2998 10.8486 16.4958L9.8623 21.4626H7.5918L8.62793 16.2449H8.62891C8.80702 15.3476 8.20062 14.6208 7.27441 14.6208H1.8457L2.2959 12.3943H7.44141ZM16.7305 2.53296L15.6934 7.75073C15.5153 8.6479 16.1217 9.37467 17.0479 9.37476H22.4766L22.0264 11.6013H16.8818C14.3906 11.6013 13.0588 9.69509 13.4736 7.49878L14.46 2.53296H16.7305Z" fill="#FFCD05"/>
    </g>
    <defs>
      <clipPath id="paint0_angular_8669_22309_clip_path">
        <rect x="0.161133" width="24" height="24" rx="3.01255"/>
      </clipPath>
      <filter id="filter0_d_8669_22309" x="-0.00045073" y="1.60988" width="24.3232" height="22.6259" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="0.923077"/>
        <feGaussianBlur stdDeviation="0.923077"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8669_22309"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8669_22309" result="shape"/>
      </filter>
    </defs>
  </svg>
)

export default CCBannerGoldUnion